export default {
  container: 'relative w-[160px] h-[58px] sm:w-[193px] rounded-xl flex items-center justify-center overflow-hidden hover:brightness-[0.98] transition duration-200',
  boxShadow: 'shadow-[0_5px_10px_rgba(0,0,0,0.05)]',
  image: 'w-[32px]',
  textWrapper: 'flex flex-col items-start ml-[16px]',
  text: 'font-inter text-[12px] text-color-lt-grey',
  storeText: 'font-interMedium text-color-black',
  beta: 'absolute bottom-0 right-0 bg-[#00518B] font-interSemibold text-[8px] sm:text-[10px] text-color-white px-[6px] sm:py-[1px] rounded-l-[32px]',
};
